import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import CommonService from "../../services/common.service";
import { useNavigate, useSearchParams } from "react-router-dom";
import PlayerGameBar from "./PlayerGameBar";
import { isUserPaid, getClubInfo } from "../../utils/userPremiumUtils";
import GamePassModal from "../GamePassModal";
import useAutoAddQueryString from "../../Helpers/useAutoAddQueryString";
const PlayerGraph = () => {
  useAutoAddQueryString();
  const [playerList, setPlayerList] = useState([]);
  const [selectedPlayerId, setSelectedPlayerId] = useState(null);
  const [isPlayerGameBarActive, setIsPlayerGameBarActive] = useState(false);
  const [isPlayerChartActive, setIsPlayerChartActive] = useState(true);
  const userPaidForClub = isUserPaid();
  const clubDetails = getClubInfo();
  let [searchParams, setSearchParams] = useSearchParams(); // Destructure setSearchParams
  const navigate = useNavigate();
  var playerId = searchParams.get("player_id");
  useEffect(() => {
    if (userPaidForClub !== 1) {
      navigate("/players");
    }

    CommonService.getPlayerList().then((res) => {
      if (res.success) {
        setPlayerList(res.data);
      }
    });
    if (playerId) {
      getPlayerGraphData(playerId);
    }
  }, [playerId]);

  const [rsData, setRsData] = useState([]);
  const [onesData, setOnesData] = useState([]);
  const [twosData, setTwosData] = useState([]);
  const [threesData, setThreesData] = useState([]);
  const [fivesData, setFivesData] = useState([]);
  const [sevensData, setSevensData] = useState([]);
  const [eightsData, setEightsData] = useState([]);
  const [ninesData, setNinesData] = useState([]);
  const [outsData, setOutsData] = useState([]);

  const [foursData, setFoursData] = useState([]);
  const [sixesData, setSixesData] = useState([]);
  const [mdnsData, setMdnsData] = useState([]);
  const [wksData, setWksData] = useState([]);

  const [csData, setCsData] = useState([]);
  const [cwksData, setCwksData] = useState([]);
  const [stsData, setStsData] = useState([]);
  const [rodsData, setRodsData] = useState([]);
  const [roasData, setRoasData] = useState([]);
  const [dksData, setDksData] = useState([]);
  const [noData, setNoData] = useState([]);
  const [hattrickData, setHattrickData] = useState([]);
  const getPlayerGraphData = (playerId) => {
    setSelectedPlayerId(playerId);
    CommonService.playerChart(playerId).then((res) => {
      if (res.status === 200) {
        setPlayerGraphDataData(res.data.datasets);
        setLabelNames(res.data.labels);
        setPriceChange(res.data.priceChange);

        setRsData(res.data.runsData);
        setOnesData(res.data.onesData);
        setTwosData(res.data.twosData);
        setThreesData(res.data.threesData);
        setFivesData(res.data.fivesData);
        setSevensData(res.data.sevensData);
        setEightsData(res.data.eightsData);
        setNinesData(res.data.ninesData);
        setOutsData(res.data.outsData);

        setFoursData(res.data.foursData);
        setSixesData(res.data.sixesData);
        setMdnsData(res.data.mdnsData);
        setWksData(res.data.wksData);

        setCsData(res.data.csData);
        setCwksData(res.data.cwksData);
        setStsData(res.data.stsData);
        setRodsData(res.data.rodsData);
        setRoasData(res.data.roasData);
        setDksData(res.data.dksData);
        setNoData(res.data.noData);
        setHattrickData(res.data.hattrickData);
      }
    });
  };

  const [playerGraphData, setPlayerGraphDataData] = useState([]);
  const [priceChange, setPriceChange] = useState([]);
  const [labelNames, setLabelNames] = useState([]);

  const [showGamePass, setShowGamePass] = useState(false);
  const handleCloseGamePass = () => setShowGamePass(false);

  const handlePlayerSelect = (playerId) => {
    if (userPaidForClub !== 1) {
      setShowGamePass(true);
      return false;
    }
    setSelectedPlayerId(playerId);
    setSearchParams({ player_id: playerId });
    if (isPlayerChartActive) {
      CommonService.playerChart(playerId).then((res) => {
        if (res.status === 200) {
          setPlayerGraphDataData(res.data.datasets);
          setLabelNames(res.data.labels);
          setPriceChange(res.data.priceChange);
          setRsData(res.data.runsData);
          setOnesData(res.data.onesData);
          setTwosData(res.data.twosData);
          setThreesData(res.data.threesData);
          setFivesData(res.data.fivesData);
          setSevensData(res.data.sevensData);
          setEightsData(res.data.eightsData);
          setNinesData(res.data.ninesData);
          setOutsData(res.data.outsData);
          setFoursData(res.data.foursData);
          setSixesData(res.data.sixesData);
          setMdnsData(res.data.mdnsData);
          setWksData(res.data.wksData);
        }
      });
    }
    if (isPlayerGameBarActive) {
      CommonService.getPlayerGameBarGraph(playerId).then((res) => {
        if (res.success) {
          setRunwRangeData(res.data);
          setWksRangeData(res.wksRangeData);
          setFoursRangeData(res.foursRangeData);
          setSixesRangeData(res.sixesRangeData);
          setMdnsRangeData(res.mdnsRangeData);
          setFpsRangeData(res.fpRangeData);
        }
      });
    }
  };

  // Fantasy Chart will show here
  // Convert strings to numbers
  const dataValues = Object.values(playerGraphData).map((value) =>
    parseFloat(value, 10)
  );
  const dataPriceChangeValues = Object.values(priceChange).map((value) =>
    parseFloat(value, 10)
  );

  const dataRunsValues = Object.values(rsData).map((value) =>
    parseFloat(value, 10)
  );

  const dataOnesValues = Object.values(onesData).map((value) =>
    parseFloat(value, 10)
  );
  const dataTwosValues = Object.values(twosData).map((value) =>
    parseFloat(value, 10)
  );
  const dataThreesValues = Object.values(threesData).map((value) =>
    parseFloat(value, 10)
  );
  const dataFivesValues = Object.values(fivesData).map((value) =>
    parseFloat(value, 10)
  );
  const dataSevensValues = Object.values(sevensData).map((value) =>
    parseFloat(value, 10)
  );
  const dataEightsValues = Object.values(eightsData).map((value) =>
    parseFloat(value, 10)
  );
  const dataNinesValues = Object.values(ninesData).map((value) =>
    parseFloat(value, 10)
  );
  const dataOutsValues = Object.values(outsData).map((value) =>
    parseFloat(value, 10)
  );

  const dataFoursValues = Object.values(foursData).map((value) =>
    parseFloat(value, 10)
  );
  const dataSixesValues = Object.values(sixesData).map((value) =>
    parseFloat(value, 10)
  );
  const dataMdnsValues = Object.values(mdnsData).map((value) =>
    parseFloat(value, 10)
  );
  const dataWksValues = Object.values(wksData).map((value) =>
    parseFloat(value, 10)
  );

  const dataCsValues = Object.values(csData).map((value) =>
    parseFloat(value, 10)
  );
  const dataCwksValues = Object.values(cwksData).map((value) =>
    parseFloat(value, 10)
  );
  const dataStsValues = Object.values(stsData).map((value) =>
    parseFloat(value, 10)
  );
  const dataRodsValues = Object.values(rodsData).map((value) =>
    parseFloat(value, 10)
  );
  const dataRoasValues = Object.values(roasData).map((value) =>
    parseFloat(value, 10)
  );
  const dataDksValues = Object.values(dksData).map((value) =>
    parseFloat(value, 10)
  );
  const dataNoValues = Object.values(noData).map((value) =>
    parseFloat(value, 10)
  );
  const dataHattrickValues = Object.values(hattrickData).map((value) =>
    parseFloat(value, 10)
  );

  const labelNamesa = Object.keys(labelNames);

  const chartData = {
    series: [
      {
        name: "Fantasy Points",
        data: dataValues,
      },
    ],
  };

  const chartOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Fantasy Points",
      align: "left",
    },
  };

  const chartData1 = {
    series: [
      {
        name: "Fantasy Value",
        data: dataPriceChangeValues,
      },
    ],
  };

  const chartOptions1 = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Fantasy Value",
      align: "left",
    },
  };

  // runs graph data
  const formattedRunseData = {
    series: [
      {
        name: "Runs",
        data: dataRunsValues,
      },
    ],
  };

  const runsOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Runs",
      align: "left",
    },
  };

  const onesOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Ones",
      align: "left",
    },
  };
  const formattedOnesData = {
    series: [
      {
        name: "Ones",
        data: dataOnesValues,
      },
    ],
  };

  const twosOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Twos",
      align: "left",
    },
  };
  const formattedTwosData = {
    series: [
      {
        name: "Twos",
        data: dataTwosValues,
      },
    ],
  };

  const threesOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Threes",
      align: "left",
    },
  };
  const formattedThreesData = {
    series: [
      {
        name: "Threes",
        data: dataThreesValues,
      },
    ],
  };

  const fivesOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Fives",
      align: "left",
    },
  };
  const formattedFivesData = {
    series: [
      {
        name: "Fives",
        data: dataFivesValues,
      },
    ],
  };

  const sevensOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Sevens",
      align: "left",
    },
  };
  const formattedSevensData = {
    series: [
      {
        name: "Sevens",
        data: dataSevensValues,
      },
    ],
  };

  const eightsOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Eights",
      align: "left",
    },
  };
  const formattedEightsData = {
    series: [
      {
        name: "Eights",
        data: dataEightsValues,
      },
    ],
  };

  const ninesOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Nines",
      align: "left",
    },
  };
  const formattedNinesData = {
    series: [
      {
        name: "Nines",
        data: dataNinesValues,
      },
    ],
  };
  const outsOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Outs",
      align: "left",
    },
  };
  const formattedOutsData = {
    series: [
      {
        name: "Outs",
        data: dataOutsValues,
      },
    ],
  };
  // fours graph data
  const formattedFoursData = {
    series: [
      {
        name: "Fours",
        data: dataFoursValues,
      },
    ],
  };

  const foursOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Fours",
      align: "left",
    },
  };
  // sixes graph data
  const formattedSixesData = {
    series: [
      {
        name: "Sixes",
        data: dataSixesValues,
      },
    ],
  };

  const sixesOptions = {
    chart: {
      id: "sixes",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Sixes",
      align: "left",
    },
  };
  // maidens graph data
  const formattedMdnsData = {
    series: [
      {
        name: "Maidens",
        data: dataMdnsValues,
      },
    ],
  };

  const mdnsOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Maidens",
      align: "left",
    },
  };
  // wks graph data
  const formattedWksData = {
    series: [
      {
        name: "Wickets",
        data: dataWksValues,
      },
    ],
  };

  const wksOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Wickets",
      align: "left",
    },
  };

  const formattedCsData = {
    series: [
      {
        name: "Catches",
        data: dataCsValues,
      },
    ],
  };

  const csOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Catches",
      align: "left",
    },
  };

  const formattedCwksData = {
    series: [
      {
        name: "Catches (Wicket-Keeper)",
        data: dataCwksValues,
      },
    ],
  };

  const cwksOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Catches (Wicket-Keeper)",
      align: "left",
    },
  };

  const formattedStsData = {
    series: [
      {
        name: "Stumpings",
        data: dataStsValues,
      },
    ],
  };

  const stsOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Stumpings",
      align: "left",
    },
  };

  const formattedRodsData = {
    series: [
      {
        name: "Run-Out Direct",
        data: dataRodsValues,
      },
    ],
  };

  const rodsOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Run-Out Direct",
      align: "left",
    },
  };

  const formattedRoasData = {
    series: [
      {
        name: "Run-Out Assisted",
        data: dataRoasValues,
      },
    ],
  };

  const roasOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Run-Out Assisted",
      align: "left",
    },
  };

  const formattedDksData = {
    series: [
      {
        name: "Duck",
        data: dataDksValues,
      },
    ],
  };

  const dksOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Duck",
      align: "left",
    },
  };

  const formattedNoData = {
    series: [
      {
        name: "Not Out",
        data: dataNoValues,
      },
    ],
  };

  const noOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Not Out",
      align: "left",
    },
  };

  const formattedHattrickData = {
    series: [
      {
        name: "Hat-Trick",
        data: dataHattrickValues,
      },
    ],
  };

  const hattrickOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Hat-Trick",
      align: "left",
    },
  };

  const [runsRangeData, setRunwRangeData] = useState([]);

  const [onesRangeData, setOnesRangeData] = useState([]);
  const [twosRangeData, setTwosRangeData] = useState([]);
  const [threesRangeData, setThreesRangeData] = useState([]);
  const [fivesRangeData, setFivesRangeData] = useState([]);
  const [sevensRangeData, setSevensRangeData] = useState([]);
  const [eightsRangeData, setEightsRangeData] = useState([]);
  const [ninesRangeData, setNinesRangeData] = useState([]);
  const [outsRangeData, setOutsRangeData] = useState([]);

  const [wksRangeData, setWksRangeData] = useState([]);
  const [foursRangeData, setFoursRangeData] = useState([]);
  const [sixesRangeData, setSixesRangeData] = useState([]);
  const [mdnsRangeData, setMdnsRangeData] = useState([]);
  const [fpsRangeData, setFpsRangeData] = useState([]);
  const [csRangeData, setCsRangeData] = useState([]);
  const [cwksRangeData, setCwksRangeData] = useState([]);
  const [stsRangeData, setStsRangeData] = useState([]);
  const [rodsRangeData, setRodsRangeData] = useState([]);
  const [roasRangeData, setRoasRangeData] = useState([]);
  const [dksRangeData, setDksRangeData] = useState([]);
  const [noRangeData, setNoRangeData] = useState([]);
  const [hattrickRangeData, setHattrickRangeData] = useState([]);

  const showPlayerGamebar = () => {
    setIsPlayerGameBarActive(true);
    setIsPlayerChartActive(false);
    if (playerId) {
      CommonService.getPlayerGameBarGraph(playerId).then((res) => {
        if (res.success) {
          setRunwRangeData(res.data);
          setOnesRangeData(res.onesRangeData);
          setTwosRangeData(res.twosRangeData);
          setThreesRangeData(res.threesRangeData);
          setFivesRangeData(res.fivesRangeData);
          setSevensRangeData(res.sevensRangeData);
          setEightsRangeData(res.eightsRangeData);
          setNinesRangeData(res.ninesRangeData);
          setOutsRangeData(res.outsRangeData);
          setWksRangeData(res.wksRangeData);
          setFoursRangeData(res.foursRangeData);
          setSixesRangeData(res.sixesRangeData);
          setMdnsRangeData(res.mdnsRangeData);
          setFpsRangeData(res.fpRangeData);

          setCsRangeData(res.csRangeData);
          setCwksRangeData(res.cwksRangeData);
          setStsRangeData(res.stsRangeData);
          setRodsRangeData(res.rodsRangeData);
          setRoasRangeData(res.roasRangeData);
          setDksRangeData(res.dksRangeData);
          setNoRangeData(res.noRangeData);
          setHattrickRangeData(res.hattrickRangeData);
        }
      });
    }
  };
  const chartTabOpen = () => {
    setIsPlayerGameBarActive(false);
    setIsPlayerChartActive(true);
  };
  return (
    <>
      <div className="middle-section">
        <div className="container">
          <div className="innerwhite-section">
            <div className="heading">
              <h2>Player Charts</h2>
            </div>
            <div className="filter_content">
              <div className="choosen_selct">
                <select
                  className="form-control"
                  disabled=""
                  onChange={(e) => handlePlayerSelect(e.target.value)}
                  value={selectedPlayerId || ""}
                >
                  <option value={""}>Select Player</option>
                  {playerList &&
                    playerList.map((item, key) => (
                      <option key={key} value={item?.id}>
                        {item?.full_name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <ul className="nav tradetab nav-tabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="Overall-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#Overall"
                  type="button"
                  role="tab"
                  aria-controls="Overall"
                  aria-selected="true"
                  onClick={chartTabOpen}
                >
                  Charts
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="Bating-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#Bating"
                  type="button"
                  role="tab"
                  aria-controls="Bating"
                  aria-selected="true"
                  onClick={showPlayerGamebar}
                >
                  Bars
                </button>
              </li>
            </ul>
            <div className="tab-content" id="timeline">
              <div
                className="tab-pane fade show active"
                id="Overall"
                role="tabpanel"
                aria-labelledby="Overall-tab"
              >
                <ul className="sponsor_list bonus-card">
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={chartOptions}
                        series={chartData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={chartOptions1}
                        series={chartData1.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={runsOptions}
                        series={formattedRunseData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>

                  {clubDetails?.game_type === 3 && (
                    <>
                      <li>
                        <div className="sponsorslide">
                          <Chart
                            options={onesOptions}
                            series={formattedOnesData.series}
                            type="line"
                            height={350}
                          />
                        </div>
                      </li>

                      <li>
                        <div className="sponsorslide">
                          <Chart
                            options={twosOptions}
                            series={formattedTwosData.series}
                            type="line"
                            height={350}
                          />
                        </div>
                      </li>
                      <li>
                        <div className="sponsorslide">
                          <Chart
                            options={threesOptions}
                            series={formattedThreesData.series}
                            type="line"
                            height={350}
                          />
                        </div>
                      </li>

                      <li>
                        <div className="sponsorslide">
                          <Chart
                            options={foursOptions}
                            series={formattedFoursData.series}
                            type="line"
                            height={350}
                          />
                        </div>
                      </li>
                      <li>
                        <div className="sponsorslide">
                          <Chart
                            options={fivesOptions}
                            series={formattedFivesData.series}
                            type="line"
                            height={350}
                          />
                        </div>
                      </li>
                      <li>
                        <div className="sponsorslide">
                          <Chart
                            options={sixesOptions}
                            series={formattedSixesData.series}
                            type="line"
                            height={350}
                          />
                        </div>
                      </li>
                      <li>
                        <div className="sponsorslide">
                          <Chart
                            options={sevensOptions}
                            series={formattedSevensData.series}
                            type="line"
                            height={350}
                          />
                        </div>
                      </li>
                      <li>
                        <div className="sponsorslide">
                          <Chart
                            options={eightsOptions}
                            series={formattedEightsData.series}
                            type="line"
                            height={350}
                          />
                        </div>
                      </li>
                      <li>
                        <div className="sponsorslide">
                          <Chart
                            options={ninesOptions}
                            series={formattedNinesData.series}
                            type="line"
                            height={350}
                          />
                        </div>
                      </li>
                      <li>
                        <div className="sponsorslide">
                          <Chart
                            options={outsOptions}
                            series={formattedOutsData.series}
                            type="line"
                            height={350}
                          />
                        </div>
                      </li>
                    </>
                  )}
                  {clubDetails?.game_type !== 3 && (
                    <>
                      <li>
                        <div className="sponsorslide">
                          <Chart
                            options={foursOptions}
                            series={formattedFoursData.series}
                            type="line"
                            height={350}
                          />
                        </div>
                      </li>
                      <li>
                        <div className="sponsorslide">
                          <Chart
                            options={sixesOptions}
                            series={formattedSixesData.series}
                            type="line"
                            height={350}
                          />
                        </div>
                      </li>
                    </>
                  )}
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={mdnsOptions}
                        series={formattedMdnsData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={csOptions}
                        series={formattedCsData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>

                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={cwksOptions}
                        series={formattedCwksData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={stsOptions}
                        series={formattedStsData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={wksOptions}
                        series={formattedWksData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={rodsOptions}
                        series={formattedRodsData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={roasOptions}
                        series={formattedRoasData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={dksOptions}
                        series={formattedDksData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={noOptions}
                        series={formattedNoData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={hattrickOptions}
                        series={formattedHattrickData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                </ul>
              </div>
              <div
                className="tab-pane fade"
                id="Bating"
                role="tabpanel"
                aria-labelledby="Bating-tab"
              >
                <PlayerGameBar
                  runsRangeData={runsRangeData}
                  onesRangeData={onesRangeData}
                  twosRangeData={twosRangeData}
                  threesRangeData={threesRangeData}
                  fivesRangeData={fivesRangeData}
                  sevensRangeData={sevensRangeData}
                  eightsRangeData={eightsRangeData}
                  ninesRangeData={ninesRangeData}
                  outsRangeData={outsRangeData}
                  wksRangeData={wksRangeData}
                  foursRangeData={foursRangeData}
                  sixesRangeData={sixesRangeData}
                  mdnsRangeData={mdnsRangeData}
                  fpsRangeData={fpsRangeData}
                  csRangeData={csRangeData}
                  cwksRangeData={cwksRangeData}
                  stsRangeData={stsRangeData}
                  rodsRangeData={rodsRangeData}
                  roasRangeData={roasRangeData}
                  dksRangeData={dksRangeData}
                  noRangeData={noRangeData}
                  hattrickRangeData={hattrickRangeData}
                  clubDetails={clubDetails}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <GamePassModal
        showGamePass={showGamePass}
        handleCloseGamePass={handleCloseGamePass}
      />
    </>
  );
};

export default PlayerGraph;
